type BankSelectionError = { title: string; description: string };

// By the error code Tink sends back from the account selection
const ERRORS: Record<string, BankSelectionError> = {
  USER_CANCELLED: {
    title: 'Inget konto valdes',
    description: 'Kontovalet avbröts. Försök igen när du är redo, eller välj Swish istället.',
  },
  AUTHENTICATION_ERROR: {
    title: 'Inloggningen hos banken misslyckades',
    description: 'Kontrollera att du loggar in med ditt eget BankID och försök igen.',
  },
  TEMPORARY_ERROR: {
    title: 'Banken svarar inte just nu',
    description: 'Det är ett tillfälligt fel. Försök igen om en stund, eller välj Swish så länge.',
  },
  INTERNAL_ERROR: {
    title: 'Banken svarar inte just nu',
    description: 'Det är ett tillfälligt fel. Försök igen om en stund, eller välj Swish så länge.',
  },
};

const FALLBACK: BankSelectionError = {
  title: 'Kontovalet gick inte igenom',
  description: 'Försök igen. Fungerar det fortfarande inte kan du välja Swish istället.',
};

export const bankSelectionError = (errorCode: string): BankSelectionError =>
  ERRORS[errorCode.toUpperCase()] ?? FALLBACK;
